// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type Me } from "../../api";
import { useMe as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useMeQueryKey(): QueryKey {
  return ["api", "v1", "me"];
}

export function useMe(
  options: Omit<UseQueryOptions<Me, ApiError>, "queryKey" | "queryFn"> = {}
): Me {
  const getter = useGetter();
  return useQuery(useMeQueryKey(), () => getter(), options).data!;
}
